import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
export type CreateAiOutlineResultFragment = { __typename?: 'Skill', id: number, draftVersion?: { __typename?: 'SkillVersion', id: string } | null, libraryItem: { __typename?: 'LibraryItem', id: string } };

export const CreateAiOutlineResultFragmentDoc = gql`
    fragment CreateAiOutlineResult on Skill {
  id
  draftVersion {
    id
  }
  libraryItem {
    id
  }
}
    `;